import { createAction } from 'redux-actions';
import { SeatMapRestrictions } from '@websky/graphql';

export const setPassengerFilter = createAction<SeatMapRestrictions>('SET_PASSENGER_FILTER');
export const clearPassengerFilters = createAction('CLEAR_PASSENGER_FILTERS');
